<script lang="ts" setup>
import { RouterLink, useRoute } from 'vue-router'
import { computed } from 'vue'
import { BookOpen, LayoutDashboard, Library, User } from 'lucide-vue-next'
import { useAuth } from '@/modules/auth'

const auth = useAuth()
const route = useRoute()

const isActive = computed(() => ({
  dashboard: route.path === '/dashboard',
  readings: route.path.startsWith('/readings'),
  library: route.path === '/books',
  account: route.path === '/account',
}))
</script>

<template>
  <nav
    v-if="auth.isAuthenticated"
    class="sm:hidden fixed bottom-0 left-0 right-0 border-t bg-background z-40"
  >
    <div class="container mx-auto px-4 py-2">
      <div class="flex items-center justify-around">
        <RouterLink
          to="/dashboard"
          data-mobile-nav-dashboard
          class="flex flex-col items-center gap-1 px-3 py-2 text-xs font-medium text-muted-foreground transition-colors"
          :class="{ 'text-primary': isActive.dashboard }"
        >
          <LayoutDashboard class="h-5 w-5" />
        </RouterLink>
        <RouterLink
          to="/readings"
          data-mobile-nav-readings
          class="flex flex-col items-center gap-1 px-3 py-2 text-xs font-medium text-muted-foreground transition-colors"
          :class="{ 'text-primary': isActive.readings }"
        >
          <BookOpen class="h-5 w-5" />
        </RouterLink>
        <RouterLink
          to="/books?by_user=true"
          data-mobile-nav-library
          class="flex flex-col items-center gap-1 px-3 py-2 text-xs font-medium text-muted-foreground transition-colors"
          :class="{ 'text-primary': isActive.library }"
        >
          <Library class="h-5 w-5" />
        </RouterLink>
        <RouterLink
          to="/account"
          data-mobile-nav-account
          class="flex flex-col items-center gap-1 px-3 py-2 text-xs font-medium text-muted-foreground transition-colors"
          :class="{ 'text-primary': isActive.account }"
        >
          <User class="h-5 w-5" />
        </RouterLink>
      </div>
    </div>
  </nav>
</template>
